import axios from "axios";

var UmRequirement = {
  initializeHeaders: function (headers) {
    axios.defaults.headers.common = headers;
  },
  get: function (health_plan_id, label_name, formulary_id) {
    return axios.get(
      Apollo.resolveApiUrl("~/umrequirements?" + "health_plan_id=" + health_plan_id + "&label_name=" + label_name + "&formulary_id=" + formulary_id),
      {
      });
    }
};

export default UmRequirement;



// WEBPACK FOOTER //
// ./src/models/UmRequirement.js